<template>
  <div>
    <div class="bjffff"></div>
    <div class="content">
      <div class="contentBox">
        <div class="title">{{ info.name }}</div>
        <div class="vidCont">
          <video :key="videoKey" controls muted :src="$imgUrl + info.video">
          </video>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      id: 0,
      info: {},
      videoKey: 0
    };
  },
  created() {
    this.init()
  },
  watch: {
    '$route.query.id'(newId, oldId) {
      if (newId !== oldId) {
        this.init()
      }
    }
  },
  methods: {
    init() {
      this.id = this.$route.query.id || 0
      this.info = {}
      this.videoKey++
      this.get()
    },

    get() {
      this.$get("/web/video_list_get", {
        id: this.id,
      }).then((res) => {
        console.log(res);
        if (res.data) {
          this.info = res.data
          this.videoKey++
        }
      });
    },
  },
  mounted() { },
  computed: {},
};
</script>
<style lang="less" scoped>
.content {
  width: 100%;

  .contentBox {
    width: 1440px;
    margin: auto;
    background-color: #f5f4f4;
    box-sizing: border-box;
    padding: 10px 15px;
  }

  .title {
    font-size: 22px;
    font-weight: 600;
    text-align: center;
    height: 80px;
    line-height: 80px;
  }

  .vidCont {
    width: 100%;
    height: 800px;
    background-color: #000;

    video {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
